import React, { forwardRef } from 'react';
import UserAvatar from './UserAvatar';
import SmartImage from './SmartImage';
import { HeartFilled } from '@ant-design/icons';

const ImageCard = forwardRef(({
  title,
  description,
  coverImage,
  author, // { name, avatar }
  likes = 0,
  is_liked = false,
  onClick,
  className = '',
  height = 'h-[268px]',
  width = 'w-[196px]',
  renderBadge, // Function to render top-left badge
  renderOverlay, // Function to render other overlays (like lock icon)
  children
}, ref) => {
  return (
    <div
      ref={ref}
      className={`bg-[var(--color-bg-container)] rounded-lg overflow-hidden cursor-pointer transition-all hover:shadow-md hover:-translate-y-1 group ${width} ${height} ${className}`}
      onClick={onClick}
    >
      <div className="w-full h-full relative overflow-hidden bg-gray-100">
        <SmartImage
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />

        {/* Bottom Gradient Overlay */}
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/80 via-black/40 to-transparent pointer-events-none"></div>

        {/* Custom Badge (Top-Left usually) */}
        {renderBadge && renderBadge()}
        
        {/* Custom Overlay (Top-Right or others) */}
        {renderOverlay && renderOverlay()}

        {/* Content Area */}
        <div className="absolute left-2 right-2 bottom-2 flex flex-col gap-1 pointer-events-none">
           <div className="pointer-events-auto">
              <h3 className="text-white text-base font-bold leading-tight line-clamp-1" title={title}>
                {title || '无标题'}
              </h3>
              <p className="text-white/80 text-xs line-clamp-1 font-semibold">
                {description || '暂无描述'}
              </p>
           </div>
          
          <div className="flex items-center justify-between pointer-events-auto">
            <div className="flex items-center gap-2">
              <UserAvatar size={20} user={author} />
              <span className="text-white text-xs truncate max-w-[80px] font-semibold">
                {author?.name || author?.nickname || 'Unknown'}
              </span>
            </div>
            {(likes !== undefined && likes !== null) && (
              <div className={`flex items-center gap-1 text-xs ${is_liked ? 'text-red-500' : 'text-white'}`}>
                <HeartFilled />
                <span>{likes}</span>
              </div>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
});

ImageCard.displayName = 'ImageCard';

export default ImageCard;
